import { HomepageNavigationItems } from "../config/nav"

export const initialState = {    
    activeProject: undefined,
    runProject: undefined,
    dashboardView: HomepageNavigationItems.ProjectList,
    dashboardNavigation: HomepageNavigationItems._id,
    projects: [],
    selectProjectMenu: {
        isCreating: false,
        isSearchTemplate: false,
    },
    tasks: [],
    compileStatus: {
        status: "ready",
        brokenProjects: [],
    },
    loadingProjectId: undefined,
    activeProjectRequiresSave: false,
    user: undefined,
    loadingIndeterminate: {
        visible: false,
        value: undefined,
        isFullApp: false
    },
    customNodeNames: {},
    errorMessage: undefined,
    plan: {
        // plan default values are the max allowed until the first plan request is made
        maxProjects: 1,
        maxSizeInputVideo: 200, 
    },
    showRunDialog: false,
    colors: {},
    unfulfilledNodes: {},
    showTutorial: false,
    showFeedbackForm: false, 
    unsavedForm: {
        show: false,
        navigation: {}
    },
    dialogs: {
        nodeInformation: {
            visible: false,
            data: undefined
        }
    },
    theme: undefined,
}

export const Dialogs = {
    NodeInformation: "nodeInformation",
}

export const persistentKeys = ['activeProject', 'dashboardView', 'dashboardNavigation', 'showTutorial']

export const Actions = {
    SetShowTutorial: "set_show_tutorial",
    SetActiveProject: "set_active_project",
    SetDashboardView: "set_dash_view",
    SetProjectList: "set_project_list",
    ToggleProjectIsCreating: "toggle_is_creating",
    ResetState: "reset_state",
    SetCompileStatus: "set_compile_status",
    SetLoadingProjectId: "set_loading_project_id",
    SetActiveProjectRequiresSave: "set_active_project_requires_save",
    NavigateDashboard: "navigate_dashboard",
    SetUser: "set_user",
    SetIndeterminate: "set_toggle_indeterminate",
    SetCustomNodeName: "set_custom_node_name",
    SetDashboardError: "set_dashboard_error",
    SetAccountPlanConstraints: "set_account_plan_constraints",
    SetShowRunDialog: "set_show_run_dialog",
    SetTasks: "set_tasks",
    SetRunProject: "set_run_project",
    SetColors: "set_colors",
    SetUnfulfilledNodes: "set_unfulfilled_nodes",
    KeepUnfulfilledNodeEntries: "keep_unfulfilled_node_entries",    
    SetShowFeedbackForm: "set_show_feedback_form",
    ToggleShowSearchTemplate: "toggle_search_template",
    SetApplicationDialog: "set_application_dialog",
    ForceNavigationUnsavedForm: "force_navigation_unsaved_form",
    CloseUnsavedForm: "close_unsaved_form",
    SetActiveProjectAndNavigate: "set_active_project_and_navigate",
    SetTheme: "set_theme",
}

export const reducer = (state, { type, payload }) => {
    switch (type) {
        case Actions.SetActiveProjectAndNavigate: {
            if (state?.activeProjectRequiresSave) {                
                return {
                    ...state,
                    unsavedForm: {
                        show: true,
                        navigation: {
                            ...state?.unsavedForm?.navigation,
                            activeProject: payload?.project,
                            customNodeNames: state?.activeProject?.id === payload?.id ? state?.customNodeNames : {},
                            dashboardView: payload?.view,
                            dashboardNavigation: payload?.nav,
                        },
                    },
                }
            }
            return {
                ...state,
                activeProject: payload?.project,
                customNodeNames: state?.activeProject?.id === payload?.id ? state?.customNodeNames : {},
                dashboardView: payload?.view,
                dashboardNavigation: payload?.nav,
            }
        }
        case Actions.CloseUnsavedForm: {
            return {
                ...state,
                unsavedForm: {
                    show: false,
                    navigation: {}
                }
            }
        }
        case Actions.ForceNavigationUnsavedForm: {            
            return {
                ...state,
                ...state?.unsavedForm?.navigation,
                unsavedForm: {
                    show: false,
                    navigation: {}
                },
                activeProjectRequiresSave: false,
            }
        }
        case Actions.ToggleShowSearchTemplate: {
            return {
                ...state,
                selectProjectMenu: {
                    ...state?.selectProjectMenu,
                    isSearchTemplate: !state?.selectProjectMenu?.isSearchTemplate,
                },
            }
        }        
        case Actions.SetActiveProjectRequiresSave: {            
            return {
                ...state,
                activeProjectRequiresSave: payload,
            }
        }
        case Actions.SetLoadingProjectId: {
            return{
                ...state,
                loadingProjectId: payload,
            }
        }
        case Actions.ResetState: {
            return initialState
        }
        case Actions.ToggleProjectIsCreating: {
            return {
                ...state,
                selectProjectMenu: {
                    ...state?.selectProjectMenu,
                    isCreating: !state?.selectProjectMenu?.isCreating,
                },
            }
        }
        case Actions.SetActiveProject: {            
            return {
                ...state,
                activeProject: payload,
                customNodeNames: state?.activeProject?.id === payload?.id ? state?.customNodeNames : {},
            }
        }
        case Actions.SetDashboardView: {            
            if (state?.activeProjectRequiresSave) {                
                return {
                    ...state,
                    unsavedForm: {
                        show: true,
                        navigation: {
                            ...state?.unsavedForm?.navigation,
                            dashboardView: payload
                        },
                    },
                }
            }
            return {
                ...state,
                dashboardView: payload,
            }
        }
        case Actions.SetProjectList: {
            return {
                ...state,
                projects: payload,
            }
        }
        case Actions.SetCompileStatus: {
            return {
                ...state,
                compileStatus: payload,
            }
        }
        
        case Actions.NavigateDashboard: {     
            if (state?.activeProjectRequiresSave) {                
                return {
                    ...state,
                    unsavedForm: {
                        show: true,
                        navigation: {
                            ...state?.unsavedForm?.navigation,
                            dashboardView: payload?.view,
                            dashboardNavigation: payload?.nav,
                        },
                    },
                }
            }

            return {
                ...state,
                dashboardView: payload?.view,
                dashboardNavigation: payload?.nav,
            }
        }
        case Actions.SetUser: {
            return {
                ...state,
                user: payload,
            }
        }
        case Actions.SetIndeterminate: {         
            if (typeof payload === 'object') {
                const isFullApp = payload?.isFullApp === true ? true : false
                return {
                    ...state,
                    loadingIndeterminate: {
                        ...payload,
                        isFullApp,
                    },
                }    
            }
            return {
                ...state,
                loadingIndeterminate: {
                    visible: payload,
                    value: undefined,
                    isFullApp: false,
                },
            }
        }
        case Actions.SetCustomNodeName: {
            return {
                ...state,                
                customNodeNames: {
                    ...state.customNodeNames,
                    [payload.id]: payload.name,
                }
            }
        }
        case Actions.SetDashboardError: {
            return {
                ...state,
                errorMessage: payload,
            }
        }
        case Actions.SetAccountPlanConstraints: {
            return {
                ...state,
                plan: payload,
            }
        }
        case Actions.SetShowRunDialog: {            
            return {
                ...state,
                showRunDialog: payload,
                runProject: undefined
            }
        }
        case Actions.SetRunProject: {
            return {
                ...state,
                runProject: payload,
                showRunDialog: !!payload,
            }
        }
        case Actions.SetTasks: {
            return {
                ...state,
                tasks: payload,
            }
        }
        case Actions.SetColors: {
            return {
                ...state,
                colors: payload,
            }
        }
        case Actions.SetUnfulfilledNodes: {
            return {
                ...state,
                unfulfilledNodes: {
                    ...state?.unfulfilledNodes,
                    [payload?.id]: payload?.value,
                }
            }
        }
        case Actions.KeepUnfulfilledNodeEntries: {
            const updated = Object.keys(state?.unfulfilledNodes).filter(x => payload.includes(x)).reduce((a,c) => {
                a[c] = state?.unfulfilledNodes[c]
                return a
            }, {})
            
            return {
                ...state,
                unfulfilledNodes: updated,
            }
        }
        case Actions.SetShowTutorial: {
            return {
                ...state,
                showTutorial: payload,
            }
        }
        case Actions.SetShowFeedbackForm: {
            return {
                ...state,
                showFeedbackForm: payload,
            }
        }
        case Actions.SetApplicationDialog : {
            return {
                ...state,
                dialogs: {
                    ...state?.dialogs,
                    [payload?.dialog]: {
                        data: payload?.data,
                        visible: payload?.visible,
                    }
                }
            }
        }
        case Actions.SetTheme: {
            return {
                ...state,
                theme: payload,
            }
        }
        default: {
            return state
        }
    }
}